import React from 'react';
import PropTypes from 'prop-types';

const BaseTags = ({ items, onClick }) => {
     const handleClick = () => {
          if (typeof onClick === 'function') {
               onClick();
          }
     };

     if (!items || items.length === 0) {
          return <></>;
     }

     return (
          <div className="base-tags">
               {items.map((item, index) => {
                    return (
                         <span key={index} index={index} className="tag-item d-flex flex-wrap align-items-center" onClick={handleClick}>
                              {item}
                         </span>
                    );
               })}
          </div>
     );
};


BaseTags.propTypes = {
     items: PropTypes.array,
     onClick: PropTypes.func,
};

export default BaseTags;
